import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

import { CountryDtoSchema } from './CountryDto'

export const UserOnboardingDetailsDtoSchema = z.strictObject({
  first_name: StringDtoSchema,
  last_name: StringDtoSchema,
  email: StringDtoSchema.email(),
  phone: StringDtoSchema.nullable(),
  street_address: StringDtoSchema.nullable(),
  street_address2: StringDtoSchema.nullable(),
  postal_code: StringDtoSchema.nullable(),
  city: StringDtoSchema.nullable(),
  country: CountryDtoSchema.nullable(),
})

export type UserOnboardingDetailsDto = z.infer<typeof UserOnboardingDetailsDtoSchema>
